import { useEffect, useState } from "react";
import { Check, Layers3, Loader2, Search, SlidersHorizontal } from "lucide-react";
import { listExportSongs } from "@/lib/exportAudioApi";
import { clock } from "@/lib/voiceSongsApi";

function Row({ s, active, onPick }) {
  return (
    <li>
      <button type="button" data-testid={`export-song-${s.id}`} aria-pressed={active} onClick={() => onPick(s.id)}
        className={`flex w-full items-center gap-3 rounded-2xl border px-3.5 py-2.5 text-left transition-colors duration-150 ${active ? "border-sky-300/50 bg-sky-400/10" : "border-transparent hover:bg-white/[0.05]"}`}>
        <span className={`grid h-5 w-5 flex-shrink-0 place-items-center rounded-full border ${active ? "border-sky-200 bg-sky-300 text-black" : "border-white/25"}`}>{active ? <Check className="h-3 w-3" /> : null}</span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-[13px] font-medium">{s.title || "Untitled"}</span>
          <span className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-white/45">
            <span>{clock(s.duration)}{s.instrumental ? " · instrumental" : ""}</span>
            {s.has_parts ? <span className="inline-flex items-center gap-1 text-cyan-200/80"><Layers3 className="h-3 w-3" /> parts ready</span> : null}
            {s.mixes ? <span className="inline-flex items-center gap-1 text-amber-200/80"><SlidersHorizontal className="h-3 w-3" /> {s.mixes} mix{s.mixes === 1 ? "" : "es"}</span> : null}
          </span>
        </span>
      </button>
    </li>
  );
}

/** Search your library and choose the song to export. */
export default function ExportSongPicker({ selected, onPick }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => listExportSongs(q).then(setRows).catch(() => setRows([])), q ? 300 : 0);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <section data-testid="export-song-picker" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-5 sm:p-6">
      <h2 className="font-display text-base font-semibold md:text-lg">1 · Choose the song</h2>
      <label className="mb-3 mt-3 flex items-center gap-2 rounded-full border border-white/10 bg-black/40 px-3.5 py-2">
        <Search className="h-4 w-4 text-white/40" />
        <input data-testid="export-song-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your songs" className="w-full bg-transparent text-[13px] text-white placeholder:text-white/35 focus:outline-none" />
      </label>
      {rows === null ? <Loader2 className="h-5 w-5 animate-spin text-white/40" /> : (
        <ul data-testid="export-song-list" className="max-h-[560px] space-y-1 overflow-y-auto pr-1">
          {rows.map((s) => <Row key={s.id} s={s} active={s.id === selected} onPick={onPick} />)}
          {!rows.length ? <li data-testid="export-song-empty" className="px-2 py-3 text-[13px] text-white/45">No songs found.</li> : null}
        </ul>
      )}
    </section>
  );
}
